"use client"

import { useEffect } from "react"

export default function TidioChat() {
  useEffect(() => {
    // Check if Tidio script is already loaded
    if (document.querySelector('script[src*="tidio.co"]')) {
      return
    }

    // Create and append the Tidio script
    const script = document.createElement('script')
    script.src = "//code.tidio.co/j8eugirdcvvtqxgjeay3r7hpvcu0c6ti.js"
    script.async = true
    document.head.appendChild(script)

    // Cleanup function
    return () => {
      const existingScript = document.querySelector('script[src*="tidio.co"]')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return null
} 